import { render, staticRenderFns } from "./article.vue?vue&type=template&id=19a751d4&scoped=true&"
var script = {}
import style0 from "./article.vue?vue&type=style&index=0&id=19a751d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a751d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19a751d4')) {
      api.createRecord('19a751d4', component.options)
    } else {
      api.reload('19a751d4', component.options)
    }
    module.hot.accept("./article.vue?vue&type=template&id=19a751d4&scoped=true&", function () {
      api.rerender('19a751d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/article.vue"
export default component.exports